import stringToHslColor from '@jimmyboys/liita-ui/dist/utils/stringToHslColor'
import { moment } from 'localization'
import capitalizeWords from '../utils/capitalizeWords'

import { dateTimeFormat } from 'localization'

import { i18n } from 'localization'
import formatPhoneNumber from 'utils/formatPhoneNumber'
/*CM 194 */
const TRANSLATION_DICTIONARY = {
	Triage: 'Triage',
	CoordinatorAllocation: 'Coordinator allocation',
	MedicalEvaluation: 'Clinical evaluation',
	FinalSituationPrevision: 'Final Situation',
	ManualIPP: 'Manual Final Situation',
	FirstIPP: 'First Final Situation',
	FollowUpIPP: 'Follow-Up Final Situation',
	Codification: 'Codification',
	MedicalActsClinicalApproval: 'Medical Acts Approval',
	SurgeryClinicalApproval: 'Surgery Approval',
	TransferClinicalApproval: 'Transfer Approval',
	RelapseClinicalApproval: 'Relapse Approval',
	RelapseOpinion: 'Relapse Opinion',
	TransferOpinion: 'Transfer Opinion',
	ClinicalFollowUpOpinion: 'Clinical FollowUp Opinion',
	FirstTriageOpinion: 'First Triage Opinion',
	//TriageOpinionFollowUp: 'TriageOpinionFollowUp',
	FollowUpTriageOpinion: 'Follow-Up Triage Opinion',
	ManagementOpinion: 'Management Opinion',
	CausalLinkOpinion: 'Causal Link Opinion',
	AppointmentClinicalApproval: 'Medical Appointment Approval',
	NonSurgicalAdmissionRequisition: 'Non Surgical Admission',
	ProcessProviderForwarding: 'Forwarding task',
	CancelRequestAppointment: 'Cancel Request Appointment',
	CancelRequestRequisition: 'Cancel Request Requisition',
	Ticket: 'Ticket',
	Invoicing: 'Invoicing',
	AmbulatoryQuote: 'Ambulatory Quote',
	SurgicalQuote: 'Surgical Quote',
	Transports: 'Transports',
	ContactClaimant: 'Contact Claimant',
	ContactProvider: 'Contact Provider',
	Clarification: 'Clarification',
	ClinicalClarification: 'Clinical Clarification',
	TechnicalAssistance: 'Technical Assistance',
}
export const translateTaskType = (taskType) => {
	if (TRANSLATION_DICTIONARY[taskType]) {
		return i18n.translate(TRANSLATION_DICTIONARY[taskType])
	}
	// console.warn('Missing translation for', taskType)
	return i18n.translate('Missing task name!')
}

export const parsePerson = (json) => {
	if (!json) return null
	const birthdayDateMoment = json.birthday
		? moment(new Date(json.birthday))
		: null

	const initials =
		json.initials ||
		`${json.firstName ? json.firstName[0] : ''}${
			json.lastName ? json.lastName[0] : ''
		}`.toUpperCase()
	const backgroundColor = stringToHslColor(initials)
	const birthday = birthdayDateMoment
		? birthdayDateMoment.format(dateTimeFormat.date || 'MMM DD, YYYY')
		: ''
	const birthdayDate = birthdayDateMoment
		? birthdayDateMoment.format('MM/DD/YYYY')
		: ''
	const age = birthdayDateMoment
		? moment().diff(birthdayDateMoment, 'years')
		: ''
	const hasContacts =
		json.contacts?.mobilePhone ||
		json.contacts?.telephone ||
		json.contacts?.email
	if (!json.name && !birthday && !hasContacts) {
		return null
	}
	const nif = parseInt(json?.nif)

	return {
		id: (json.id?.toString() || '').toLowerCase(),
		name: json.name ? capitalizeWords(json.name) : '',
		initials,
		birthday,
		birthdayInfo: {
			birthdayDateMoment,
			birthdayDate,
		},
		age,
		nif,
		gender: json.gender,
		backgroundColor,
		contacts: hasContacts
			? {
					mobile: json.contacts.mobilePhone,
					telephone: json.contacts.telephone,
					email: json.contacts.email,
			  }
			: null,
		formattedPhoneContacts: {
			mobile: formatPhoneNumber(json.contacts?.mobilePhone),
			telephone: formatPhoneNumber(json.contacts?.telephone),
		},
		localeWithPostalCode: [json?.postalCode, json?.locale]
			.filter(Boolean)
			.join(', '),
		address: json?.address,
		postalCode: json?.postalCode,
		district: json?.district,
		isFromIsland: json?.isFromIslands,
		profession: json?.profession,
		professionId: json?.professionId,
		formattedAddress: [
			json?.address?.includes(json?.postalCode)
				? undefined
				: json?.postalCode,
			json?.address?.includes(json?.locale) ? undefined : json?.locale,
			json?.address?.trim?.(),
		]
			.filter(Boolean)
			.join(', '),
	}
}

export const parseDate = (dateStr, ignoreComplexObjects) => {
	const dateInstance = new Date(dateStr)
	const dateTime = moment(dateInstance)
	const date = dateTime.format(dateTimeFormat.date || 'MMM DD, YYYY')
	const tinyDate = dateTime.format(dateTimeFormat.tiny || 'MM/DD/YY')
	const time = dateTime.format(dateTimeFormat.time || 'HH:mm')
	const dateTimeString = dateTime
		.clone()
		.format(dateTimeFormat.dateTime || 'MMM DD, YYYY [at] HH:mm[h]')
	const separatedDateFormat = {
		day: dateTime.format('DD'),
		month: dateTime.format('MMM'),
		fullMonth: dateTime.format('MMMM'),
		year: dateTime.format('YYYY'),
	}

	return {
		UTC: dateStr,
		date: ignoreComplexObjects ? undefined : dateInstance,
		momentDate: ignoreComplexObjects ? undefined : dateTime,
		startOfDay: ignoreComplexObjects
			? undefined
			: dateTime.clone().startOf('day'),
		nextDay: ignoreComplexObjects
			? undefined
			: dateTime.clone().startOf('day').add(1, 'day'),
		timestamp: dateInstance.getTime(),
		tinyDateFormat: tinyDate,
		shortDateFormat: date,
		shortTimeFormat: time,
		dateTimeFormat: dateTimeString,
		fromNow: dateTime.fromNow(),
		daysFromNow: moment().diff(dateTime, 'days'),
		separatedDateFormat,
	}
}

export const HSLToHex = (hsl) => {
	let sep = hsl.indexOf(',') > -1 ? ',' : ' '
	hsl = hsl.substr(4).split(')')[0].split(sep)

	let h = hsl[0],
		s = hsl[1].substr(0, hsl[1].length - 1) / 100,
		l = hsl[2].substr(0, hsl[2].length - 1) / 100

	// Strip label and convert to degrees (if necessary)
	if (h.indexOf('deg') > -1) h = h.substr(0, h.length - 3)
	else if (h.indexOf('rad') > -1)
		h = Math.round(h.substr(0, h.length - 3) * (180 / Math.PI))
	else if (h.indexOf('turn') > -1)
		h = Math.round(h.substr(0, h.length - 4) * 360)
	h = parseInt(h, 10)
	if (h >= 360) h %= 360

	let c = (1 - Math.abs(2 * l - 1)) * s,
		x = c * (1 - Math.abs(((h / 60) % 2) - 1)),
		m = l - c / 2,
		r = 0,
		g = 0,
		b = 0

	if (0 <= h && h < 60) {
		r = c
		g = x
		b = 0
	} else if (60 <= h && h < 120) {
		r = x
		g = c
		b = 0
	} else if (120 <= h && h < 180) {
		r = 0
		g = c
		b = x
	} else if (180 <= h && h < 240) {
		r = 0
		g = x
		b = c
	} else if (240 <= h && h < 300) {
		r = x
		g = 0
		b = c
	} else if (300 <= h && h < 360) {
		r = c
		g = 0
		b = x
	}
	// Having obtained RGB, convert channels to hex
	r = Math.round((r + m) * 255).toString(16)
	g = Math.round((g + m) * 255).toString(16)
	b = Math.round((b + m) * 255).toString(16)

	// Prepend 0s, if necessary
	if (r.length === 1) r = '0' + r
	if (g.length === 1) g = '0' + g
	if (b.length === 1) b = '0' + b

	return '#' + r + g + b
}
